{
  "APP_NAME": "verein.cloud®",
  "Verein": "Verein",
  "Vereins": "Vereins",
  "ABOUT_VEREIN": "Mit verein.Cloud® eröffnen wir Mehrwert und Einkommensquellen für Vereine, die über die Premium-Einnahmen hinausgehen. Eine Spendenplattform ermöglicht automatisierten Zugang zur Finanzierung von Plänen und Projekten. Mit dem profilierten Zugang zu Vereinsmitgliedern können Vereine ihre Sponsoren nachhaltiger integrieren. Mitglieder und Vereine profitieren von Treue-, Gutschein- oder Cashback-Funktionen und weiteren Mehrwerten und Dienstleistungen.",
  "PASSWORD_RESET_SUCCESS_MESSAGE": "Ein Link zum Zurücksetzen des Passworts wurde gesendet. Überprüfen Sie Ihr Postfach auf eine E-Mail von support@verein.cloud.",
  "New Version is Available.": "Eine neue Version ist verfügbar.",
  "Please Click to Update": "Zum aktualisiert bitte klicken",
  "Forgot Password": "Passwort vergessen",
  "Back to login": "Zurück zur Anmeldung",
  "Submit": "Einreichen",
  "Welcome": "Willkommen",
  "Login Successful": "Anmeldung erfolgreich",
  "Admin": "Administrator",
  "Member": "Mitglied",
  "Guest": "Gast",
  "Secretary": "Sekretär",
  "Functionary": "Funktionär",
  "Editor": "Editor",
  "User": "Benutzer",
  "Member Light": "Member Light",
  "Member Light Admin": "Admin Light",
  "About": "Über",
  "Chairman": "Vorstand",
  "Hello world !": "Hallo welt !",
  "Not Found": "Nicht gefunden",
  "Unauthorized Access": "Unbefugter Zugriff",
  "Home": "Startseite",
  "Logged in as": "Angemeldet als",
  "Login": "Anmelden",
  "Logout": "Abmelden",
  "Password": "Passwort",
  "Confirm Password": "Passwort bestätigen",
  "Password is required": "Passwort wird benötigt",
  "Username": "Benutzername",
  "Username is required": "Benutzername wird benötigt",
  "Username or password incorrect.": "Benutzername oder Passwort falsch.",
  "Remember me": "Eingeloggt bleiben",
  "Version": "Version",
  "Details": "Details",
  "Yes": "Ja",
  "No": "Nein",
  "Old Password": "Altes Passwort",
  "New Password": "Neues Passwort",
  "Confirmation": "Bestätigung",
  "Delete Confirmation": "Löschbestätigung",
  "Move to Trash Confirmation": "In den Papierkorb verschieben Bestätigung",
  "Leave Confirmation": "Austrittsbestätigung",
  "Join Confirmation": "Beitrittsbestätigung",
  "Approve Join Confirmation": "Beitrittsbestätigung genehmigen",
  "Accept Confirmation": "Bestätigung akzeptieren",
  "Deny Confirmation": "Bestätigung verweigern",
  "Approve Confirmation": "Bestätigung genehmigen",
  "Reject Confirmation": "Bestätigung ablehnen",
  "Shifts Delete Confirmation": "Schichten löschen Bestätigung",
  "Accept Successful": "Akzeptieren erfolgreich",
  "Deny Successful": "Ablehnen erfolgreich",
  "Unapprove Successful": "Nicht genehmigen erfolgreich",
  "Approve Successful": "Genehmigen erfolgreich",
  "Created Successfully": "Erfolgreich erstellt",
  "Update Successful": "Aktualisierung erfolgreich",
  "Delete Successful": "Erfolgreich gelöscht",
  "Leave Successful": "Erfolgreich verlassen",
  "Join Successful": "Erfolgreich beigetreten",
  "Approved Successfully": "Genehmigt erfolgreich",
  "Rejected Successfully": "Abgelehnt erfolgreich",
  "Message starred successfully": "Nachricht erfolgreich markiert",
  "Message moved to inbox successfully": "Nachricht erfolgreich in den Posteingang verschoben",
  "Message saved as draft successfully": "Nachricht erfolgreich als Entwurf gespeichert",
  "Message moved to trash successfully": "Nachricht erfolgreich in den Papierkorb verschoben",
  "Error": "Fehler",
  "Something went wrong": "Es ist ein Fehler aufgetreten!",
  "Are you sure you want to continue": "Bist du sicher, dass sie fortfahren möchtest",
  "Are you sure you want to delete": "Sind sie sicher, dass sie löschen möchten",
  "Are you sure you want to leave": "Sind sie sicher, dass sie austreten möchtest",
  "Are you sure you want to join": "Sind sie sicher, dass sie beitreten möchten",
  "Are you sure you want to join {eventName} event on {eventDate}?": "Sind Sie sicher, dass Sie dem Event <b>'{{eventName}}'</b> am <b>{{eventDate}}</b> beitreten möchten?",
  "Are you sure you want to join {eventName} for all upcoming events?": "Sind Sie sicher, dass Sie dem Event <b>'{{eventName}}'</b> für alle kommenden Events beitreten möchten?",
  "Are you sure you want to join {eventName} event on selected dates?": "Sind Sie sicher, dass Sie dem Event <b>'{{eventName}}'</b> am ausgewählten Datum beitreten möchten?",
  "Your current Request is waiting for the Approval": "Ihre aktuelle Anfrage wartet auf die Genehmigung.",
  "Current Request is waiting for the Approval by Admin": "Aktuelle Anfrage wartet auf die Genehmigung durch den Administrator",
  "Current request has been denied": "Aktuelle Anfrage wurde abgelehnt",
  "Your current request is Rejected": "Ihre aktuelle Anfrage wurde abgelehnt",
  "Your current request is Approved": "Ihre aktuelle Anfrage wurde genehmigt",
  "Deny Reason": "Ablehnungsgrund",
  "Your current Request is waiting for the Approval by Admin": "Ihr aktueller Antrag wartet auf die Genehmigung durch den Administrator.",
  "Your current request is Denied by Admin": "Ihr aktueller Antrag wurde vom Administrator abgelehnt.",
  "Your update request is waiting for the approval by Admin": "Ihr Aktualisierungsantrag wartet auf die Genehmigung durch den Administrator.",
  "Update request is waiting for the approval": "Aktualisierungsantrag wartet auf die Genehmigung",
  "You have unsaved changes. Are you sure you want to leave": "Du hast ungespeicherte Änderungen. Bist du sicher, dass du die Seite verlassen möchtest",
  "confirmationDivider": "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------",
  "Are you sure you want to accept this": "Sind Sie sicher, dass Sie dies akzeptieren möchten ",
  "Are you sure you want to deny this": "Sind Sie sicher, dass Sie dies ablehnen möchten ",
  "Are you sure you want to approve this": "Sind Sie sicher, dass Sie dies genehmigen möchten ",
  "Are you sure you want to reject this": "Sind Sie sicher, dass Sie dies ablehnen möchten ",
  "Are you sure you want to unapprove this": "Sind Sie sicher, dass Sie dies nicht genehmigen möchten ",
  "Are you sure you want to accept this Course": "Sind Sie sicher, dass Sie diesen Kurs akzeptieren möchten",
  "Are you sure you want to deny this Course": "Sind Sie sicher, dass Sie diesen Kurs ablehnen möchten",
  "Are you sure you want to approve this Course": "Sind Sie sicher, dass Sie diesen Kurs genehmigen möchten",
  "Are you sure you want to reject this Course": "Sind Sie sicher, dass Sie diesen Kurs ablehnen möchten",
  "Are you sure you want to unapprove this Course": "Sind Sie sicher, dass Sie diesen Kurs nicht genehmigen möchten",
  "Are you sure you want to accept this Event": "Sind Sie sicher, dass Sie dieses Event akzeptieren möchten",
  "Are you sure you want to deny this Event": "Sind Sie sicher, dass Sie dieses Event ablehnen möchten",
  "Are you sure you want to approve this Event": "Sind Sie sicher, dass Sie dieses Event genehmigen möchten",
  "Are you sure you want to reject this Event": "Sind Sie sicher, dass Sie dieses Event ablehnen möchten",
  "Are you sure you want to unapprove this Event": "Sind Sie sicher, dass Sie dieses Event nicht genehmigen möchten",
  "Are you sure you want to accept this News": "Sind Sie sicher, dass Sie diese News akzeptieren möchten",
  "Are you sure you want to deny this News": "Sind Sie sicher, dass Sie diese News ablehnen möchten",
  "Are you sure you want to approve this News": "Sind Sie sicher, dass Sie diese News genehmigen möchten",
  "Are you sure you want to reject this News": "Sind Sie sicher, dass Sie diese News ablehnen möchten",
  "Are you sure you want to unapprove this News": "Sind Sie sicher, dass Sie diese News nicht genehmigen möchten",
  "Are you sure you want to accept this Task": "Sind Sie sicher, dass Sie diese Aufgabe akzeptieren möchten",
  "Are you sure you want to deny this Task": "Sind Sie sicher, dass Sie diese Aufgabe ablehnen möchten",
  "Are you sure you want to approve this Task": "Sind Sie sicher, dass Sie diese Aufgabe genehmigen möchten",
  "Are you sure you want to reject this Task": "Sind Sie sicher, dass Sie diese Aufgabe ablehnen möchten",
  "Are you sure you want to unapprove this Task": "Sind Sie sicher, dass Sie diese Aufgabe nicht genehmigen möchten",
  "Are you sure you want to accept this Group": "Sind Sie sicher, dass Sie diese Gruppe akzeptieren möchten",
  "Are you sure you want to deny this Group": "Sind Sie sicher, dass Sie diese Gruppe ablehnen möchten",
  "Are you sure you want to approve this Group": "Sind Sie sicher, dass Sie diese Gruppe genehmigen möchten",
  "Are you sure you want to reject this Group": "Sind Sie sicher, dass Sie diese Gruppe ablehnen möchten",
  "Are you sure you want to unapprove this Group": "Sind Sie sicher, dass Sie diese Gruppe nicht genehmigen möchten",
  "Are you sure you want to accept this FAQ": "Sind Sie sicher, dass Sie diese FAQ akzeptieren möchten",
  "Are you sure you want to deny this FAQ": "Sind Sie sicher, dass Sie diese FAQ ablehnen möchten",
  "Are you sure you want to approve this FAQ": "Sind Sie sicher, dass Sie diese FAQ genehmigen möchten",
  "Are you sure you want to reject this FAQ": "Sind Sie sicher, dass Sie diese FAQ ablehnen möchten",
  "Are you sure you want to unapprove this FAQ": "Sind Sie sicher, dass Sie diese FAQ nicht genehmigen möchten",
  "Are you sure you want to accept this Instructor": "Sind Sie sicher, dass Sie diesen Dozenten akzeptieren möchten",
  "Are you sure you want to deny this Instructor": "Sind Sie sicher, dass Sie diesen Dozenten ablehnen möchten",
  "Are you sure you want to approve this Instructor": "Sind Sie sicher, dass Sie diesen Dozenten genehmigen möchten",
  "Are you sure you want to reject this Instructor": "Sind Sie sicher, dass Sie diesen Dozenten ablehnen möchten",
  "Are you sure you want to unapprove this Instructor": "Sind Sie sicher, dass Sie diesen Dozenten nicht genehmigen möchten",
  "Are you sure you want to accept this Room": "Sind Sie sicher, dass Sie diesen Raum akzeptieren möchten",
  "Are you sure you want to deny this Room": "Sind Sie sicher, dass Sie diesen Raum ablehnen möchten",
  "Are you sure you want to approve this Room": "Sind Sie sicher, dass Sie diesen Raum genehmigen möchten",
  "Are you sure you want to reject this Room": "Sind Sie sicher, dass Sie diesen Raum ablehnen möchten",
  "Are you sure you want to unapprove this Room": "Sind Sie sicher, dass Sie diesen Raum nicht genehmigen möchten",
  "Are you sure you want to accept this Survey": "Sind Sie sicher, dass Sie diese Umfrage akzeptieren möchten",
  "Are you sure you want to deny this Survey": "Sind Sie sicher, dass Sie diese Umfrage ablehnen möchten",
  "Are you sure you want to approve this Survey": "Sind Sie sicher, dass Sie diese Umfrage genehmigen möchten",
  "Are you sure you want to reject this Survey": "Sind Sie sicher, dass Sie diese Umfrage ablehnen möchten",
  "Are you sure you want to unapprove this Survey": "Sind Sie sicher, dass Sie diese Umfrage nicht genehmigen möchten",
  "Are you sure you want to delete all shifts for": "Sind Sie sicher, dass Sie alle Schichten für löschen möchten",
  "Are you sure you want to move this to trash": "Sind Sie sicher, dass Sie dies in den Papierkorb verschieben möchten",
  "Are you sure you want to permanently delete this": "Sind Sie sicher, dass Sie dies dauerhaft löschen möchten",
  "Are you sure you want to approve this join request": "Sind Sie sicher, dass Sie diese Beitrittsanfrage genehmigen möchten",
  "Are you sure you want to delete this image": "Sind Sie sicher, dass Sie dieses Bild löschen möchten",
  "Are you sure you want to delete this document": "Sind Sie sicher, dass Sie dieses Dokument löschen möchten",
  "Are you sure you want to complete this task": "Sind Sie sicher, dass Sie diese Aufgabe abschließen möchten",
  "Club Surveys": "Vereinsumfragen",
  "Active Polls": "Aktive Umfragen",
  "My Polls": "Meine Umfragen",
  "Completed Polls": "Abgeschlossene Umfragen",
  "Completed Surveys": "Abgeschlossene Umfragen",
  "Opinion Poll": "Meinungsumfrage",
  "owner": "Besitzer",
  "Active on": "Aktiv am",
  "Active from": "Aktiv von",
  "Expired on": "Abgelaufen am",
  "remaining time": "Verbleibende Zeit",
  "status": "Status",
  "Add Survey": "Umfrage hinzufügen",
  "View Survey": "Umfrage anzeigen",
  "Delete Survey": "Umfrage löschen",
  "Active Survey": "Aktive Umfrage",
  "Close Survey": "Umfrage schließen",
  "Survey Activated Successfully": "Umfrage erfolgreich aktiviert",
  "Survey Closed Successfully": "Umfrage erfolgreich geschlossen",
  "Survey Close Confirmation": "Umfrage-Schließbestätigung",
  "Survey Active Confirmation": "Umfrage-Aktivbestätigung",
  "Are you sure you want to active": "Sind Sie sicher, dass Sie aktivieren möchten",
  "Are you sure you want to close": "Sind Sie sicher, dass Sie schließen möchten",
  "Leave": "Verlassen",
  "Edit": "Bearbeiten",
  "Delete": "Löschen",
  "Remove": "Entfernen",
  "Add": "Hinzufügen",
  "Create": "Erstellen",
  "Save": "Speichern",
  "Update": "Aktualisieren",
  "update": "Aktualisieren",
  "Cancel": "Abbrechen",
  "Back": "Zurück",
  "accept": "Akzeptieren",
  "Accept": "Akzeptieren",
  "Decline": "Ablehnen",
  "deny": "Ablehnen",
  "Deny": "Ablehnen",
  "view": "Ansehen",
  "View": "Ansehen",
  "view survey": "Umfrage ansehen",
  "view task": "Aufgabe ansehen",
  "View Task": "Aufgabe ansehen",
  "Drag and drop image here, or click to add image": "Bild hierher ziehen oder klicken, um ein Bild hinzuzufügen",
  "Drag and drop image here, or click to change image": "Bild hierher ziehen oder klicken, um das Bild zu ändern",
  "Drag and drop file here, or click to add file": "Datei hierher ziehen oder klicken, um eine Datei hinzuzufügen",
  "Drag and drop file here, or click to change file": "Datei hierher ziehen oder klicken, um die Datei zu ändern",
  "Add Image": "Bild hinzufügen",
  "Add File": "Datei hinzufügen",
  "Change Image": "Bild ändern",
  "View more": "Mehr anzeigen",
  "Notifications": "Benachrichtigungen",
  "See more Notifications": "Mehr Benachrichtigungen anzeigen",
  "Title": "Titel",
  "Start Date": "Startdatum",
  "End Date": "Enddatum",
  "New Survey": "Neue Umfrage",
  "Survey Edit": "Umfrage bearbeiten",
  "Survey Details": "Umfrage Details",
  "Survey": "Umfrage",
  "Question": "Frage",
  "Single selection": "Einzelne Auswahl",
  "Multiple selection": "Mehrfachauswahl",
  "Add Choice": "Auswahl hinzufügen",
  "Enter your question": "Geben Sie Ihre Frage ein",
  "Publish": "Veröffentlichen",
  "Add Question": "Frage hinzufügen",
  "Enter your survey name": "Geben Sie Ihren Umfragenamen ein",
  "Assigned tasks": "Zugewiesene Aufgaben",
  "About event": "Über das Event",
  "Event details": "Event Details",
  "Clear All": "Alle löschen",
  "Select Date": "Datum auswählen",
  "Delete Banner": "Banner löschen",
  "Banner": "Banner",
  "Banners": "Banner",
  "Email Type": "E-Mail-Typ",
  "Subject": "Betreff",
  "To": "An",
  "Cc": "CC",
  "Recipients": "Empfänger",
  "Edit Draft Message": "Entwurf bearbeiten",
  "Header Content": "Kopfinhalt",
  "Template Body": "Vorlageninhalt",
  "Footer Content": "Fußzeileninhalt",
  "Url": "URL",
  "Action": "Aktion",
  "Thumbnail": "Miniaturansicht",
  "From": "Von",
  "Template Type": "Vorlagentyp",
  "Header Subject": "Kopfbetreff",
  "Email Template": "E-Mail-Vorlage",
  "Create Email Template": "E-Mail-Vorlage erstellen",
  "Content": "Inhalt",
  "instructor": "Kursleiter",
  "survey": "Umfrage",
  "course": "Kurs",
  "updatedcourse": "Aktualisierter Kurs",
  "Select Option": "Option auswählen",
  "Select Options": "Optionen auswählen",
  "Tag": "Tag",
  "Tags": "Tags",
  "Tag Name": "Tag Name",
  "Create Tag": "Tag erstellen",
  "Instructor Tag Name": "Kursleiter Tag Name",
  "Room Tag Name": "Raum Tag Name",
  "Courses": "Kurse",
  "Instructor": "Kursleiter",
  "Room": "Raum",
  "Rooms": "Räume",
  "New Tag": "Neuer Tag",
  "Task": "Aufgabe",
  "task": "Aufgabe",
  "Event": "Event",
  "Events": "Events",
  "Event Name": "Event Name",
  "Event Type": "Eventtyp",
  "FAQs": "FAQs",
  "Surveys": "Umfragen",
  "News": "News",
  "news": "News",
  "news posts": "Nachrichtenbeiträge",
  "news post": "Nachrichtenbeitrag",
  "create news post": "Nachrichtenbeitrag erstellen",
  "edit news post": "Nachrichtenbeitrag bearbeiten",
  "news post details": "Details des Nachrichtenbeitrags",
  "discover": "Entdecken",
  "create news": "Nachrichten erstellen",
  "news from the groups": "Nachrichten aus der Gruppe",
  "No Available Content": "Kein verfügbarer Inhalt",
  "re you sure you want to delete this Tag?": "Sind Sie sicher, dass Sie diesen Tag löschen möchten?",
  "Update Tag": "Tag aktualisieren",
  "Add task": "Aufgabe hinzufügen",
  "Tasks": "Aufgaben",
  "Task details": "Aufgabendetails",
  "Create task": "Aufgabe erstellen",
  "Edit task": "Aufgabe bearbeiten",
  "All tasks": "Alle Aufgaben",
  "My tasks": "Meine Aufgaben",
  "Completed tasks": "Abgeschlossene Aufgaben",
  "Open tasks": "Offene Aufgaben",
  "Group tasks": "Gruppenaufgaben",
  "New task": "Neue Aufgabe",
  "Subtasks": "Unteraufgaben",
  "Add Sub-task": "Unteraufgabe hinzufügen",
  "Select date": "Datum auswählen",
  "Select Time": "Zeit auswählen",
  "ToDo": "ToDo",
  "In-Progress": "In Bearbeitung",
  "InProgress": "In Bearbeitung",
  "Completed": "Abgeschlossen",
  "Comments": "Kommentare",
  "Assigned": "Zugewiesen",
  "Assign to": "Zugewiesen an",
  "Add a Card": "Karte hinzufügen",
  "Add Card": "Karte hinzufügen",
  "Add element": "Element hinzufügen",
  "Enter a title for this card": "Geben Sie einen Titel für diese Karte ein",
  "Tasks to be completed": "Aufgaben, die erledigt werden müssen",
  "No Available Tasks": "Keine verfügbaren Aufgaben",
  "Group": "Gruppe",
  "Individual": "Individuell",
  "Task type": "Aufgabentyp",
  "Add Tag": "Tag hinzufügen",
  "Enter Title": "Titel eingeben",
  "Enter Description": "Beschreibung eingeben",
  "Select": "Auswählen",
  "News Posts": "Nachrichtenbeiträge",
  "Posts": "Beiträge",
  "Message Chats": "Nachrichten-Chats",
  "Message": "Nachricht",
  "Chats": "Chats",
  "Tasks Events": "Aufgaben-Events",
  "news from the club": "Nachrichten aus dem Verein",
  "News from the group": "Nachrichten aus der Gruppe",
  "News from the Company": "Nachrichten aus dem Unternehmen",
  "Current club dates": "Aktuelle Termine im Verein",
  "Current company dates": "Aktuelle Unternehmens-Termine",
  "Participant": "Teilnehmer",
  "Read more": "Mehr lesen",
  "Clock": "Uhr",
  "Popular": "Beliebt",
  "Latest": "Neueste",
  "Available Tasks": "Verfügbare Aufgaben",
  "Available": "Verfügbar",
  "New": "Neu",
  "No News": "Keine Nachrichten",
  "Menu": "Menü",
  "Answer Options": "Antwortoptionen",
  "Enter answer choice": "Antwortmöglichkeiten eingeben",
  "Answer": "Antwort",
  "Survey Type": "Umfragetyp",
  "Type": "Typ",
  "View Options": "Ansichtsoptionen",
  "Notification": "Benachrichtigung",
  "Anonymous Voting": "Anonyme Abstimmung",
  "Allow Correcting the Cast Vote": "Korrektur der abgegebenen Stimme zulassen",
  "Multiple Choice": "Mehrfach Auswahl",
  "Single Choice": "Einzelne Auswahl",
  "Web Notification": "Web benachrichtigung",
  "Email Notification": "E-Mail benachrichtigung",
  "Always": "Immer",
  "After Voting": "Nach der Abstimmung",
  "Never": "Nie",
  "All Club": "Alle Vereine",
  "All Important Dates": "Alle wichtigen Termine",
  "Jubilees": "Jubiläen",
  "Birthdays": "Geburtstage",
  "Anniversary": "Jahrestag",
  "Birthday": "Geburtstag",
  "days ago": "Tage her",
  "days left": "Tage übrig",
  "years": "Jahre",
  "years in club": "Jahre im Verein",
  "Today": "Heute",
  "Today is": "Heute ist",
  "No upcoming birthdays or anniversaries": "Keine bevorstehenden Geburtstage oder Jubiläen",
  "Say Congrats": "Sagen Sie Glückwunsch",
  "Reply": "Antworten",
  "Reply All": "Allen antworten",
  "Forward": "Weiterleiten",
  "No Messages": "Keine Nachrichten",
  "All Events": "Alle Events",
  "Club Event": "Vereins-Event",
  "Group Event": "Gruppen-Event",
  "Functionaries Event": "Funktionärs-Event",
  "Course": "Kurs",
  "Seminar": "Seminar",
  "Items Per Page": "Elemente pro Seite",
  "Description": "Beschreibung",
  "Enter to search": "Drücken Sie Enter, um zu suchen",
  "New Chat": "Neuer Chat",
  "Email": "Nachrichten",
  "E-Mail": "E-Mail",
  "New Email": "Neue Nachricht",
  "Select an email to start communication": "Wählen Sie eine E-Mail aus, um die Kommunikation zu starten",
  "Select a chat to start messaging": "Wählen Sie einen Chat aus, um die Nachrichten zu starten",
  "Looks like you haven’t initiated a conversation with any of your team members": "Sie haben anscheinend noch keine Konversation mit einem Ihrer Teammitglieder gestartet",
  "Enter your survey description": "Geben Sie Ihre Umfragebeschreibung ein",
  "Manage members and set their access level in your workspace": "Verwalten Sie Mitglieder und legen Sie ihren Zugriffslevel in Ihrem Arbeitsbereich fest",
  "New Message": "Neue Nachricht",
  "Message Type": "Nachrichtentyp",
  "Add a subject...": "Fügen Sie ein Thema hinzu...",
  "Select A Message": "Wählen Sie eine Nachricht",
  "Choose File": "Datei auswählen",
  "Change File": "Datei ändern",
  "Type a message...": "Geben Sie eine Nachricht ein...",
  "Draft": "Entwurf",
  "Drafts": "Entwürfe",
  "Send": "Senden",
  "Bin": "Papierkorb",
  "All Messages": "Alle Nachrichten",
  "Posted": "Gepostet",
  "Marked": "Markiert",
  "Inbox": "Posteingang",
  "Trash": "Papierkorb",
  "Starred": "Markiert",
  "Sent": "Gesendet",
  "All Mails": "Alle E-Mails",
  "Personal": "Persönliche",
  "Sorting": "Sortierung",
  "Active Member": "Aktives Mitglied",
  "Membership number": "Mitgliedsnummer",
  "In the team since": "Im Team seit",
  "In the club since": "Im Verein seit",
  "Category": "Kategorie",
  "Position": "Position",
  "Category Name": "Kategoriename",
  "Select Language": "Sprache auswählen",
  "Select Theme": "Modus wählen",
  "No record found": "Kein Eintrag gefunden",
  "No items available": "Keine items vorhanden",
  "No tags available": "Keine Tags vorhanden",
  "Faq Category": "FAQ Kategorie",
  "Internal": "Intern",
  "External": "Extern",
  "Booked Out": "Ausgebucht",
  "Internal Instructor": "Interner Kursleiter",
  "External Instructor": "Externer Kursleiter",
  "Instructor Type": "Kursleiter Typ",
  "Faq Category Name": "FAQ Kategoriename",
  "Sort and Filter": "Sortieren und Filtern",
  "Clear": "Löschen",
  "Select Tags": "Tags auswählen",
  "Name of the Event": "Name des Events",
  "Venue": "Veranstaltungsort",
  "Add Venue": "Veranstaltungsort hinzufügen",
  "No venue available": "Kein Veranstaltungsort verfügbar",
  "Event Venues": "Veranstaltungsorte",
  "Create Event Venue": "Veranstaltungsort erstellen",
  "Event Venue Name": "Veranstaltungsort Name",
  "Event Types": "Eventtypen",
  "Visibility of Event": "Sichtbarkeit des Events",
  "Show Guests": "Gästen anzeigen",
  "Chargeable": "Kostenpflichtig",
  "Additional Features": "Zusätzliche Funktionen",
  "Event Price": "Eventpreis",
  "Assign a task to an event": "Veranstaltung eine Aufgabe zuweisen",
  "Task Description": "Aufgabenbeschreibung",
  "Task Types": "Aufgabentypen",
  "Week Days": "Wochentage",
  "Recurrence": "Wiederholung",
  "Start Time": "Startzeit",
  "End Time": "Endzeit",
  "Event Date": "Eventdatum",
  "Event Time": "Eventzeit",
  "Room No (optional)": "Raum Nr (optional)",
  "Repeat Event": "Event wiederholen",
  "Image": "Bild",
  "Enter Price": "Preis eingeben",
  "Time From": "Von Uhrzeit",
  "Time To": "Bis Uhrzeit",
  "Every": "Jeden",
  "Days": "Tage",
  "Weeks": "Wochen",
  "Months": "Monate",
  "Years": "Jahre",
  "Day": "Tag",
  "Repeat Daily": "Täglich wiederholen",
  "Repeat Weekly": "Wöchentlich wiederholen",
  "Repeat Monthly": "Monatlich wiederholen",
  "Repeat Yearly": "Jährlich wiederholen",
  "Public": "Öffentlich",
  "Private": "Privat",
  "Club": "Verein",
  "Clubs": "Vereins",
  "Company": "Unternehmen",
  "Does Not Repeat": "Wiederholt sich nicht",
  "Every Day": "Jeden Tag",
  "Every Week": "Jede Woche",
  "Every Month": "Jeden Monat",
  "Every Year": "Jedes Jahr",
  "Custom": "Benutzerdefiniert",
  "Club  Event": "Vereinsveranstaltung",
  "Select Participants": "Teilnehmer auswählen",
  "Participants": "Teilnehmer",
  "Private Group": "Private Gruppe",
  "Course Information": "Kursinformationen",
  "Place": "Ort",
  "Date": "Datum",
  "Time": "Zeit",
  "Instructor Name": "Kursleiterenname",
  "Available Times": "Verfügbare Zeiten",
  "Qualification": "Qualifikation",
  "More Courses": "Weitere Kurse",
  "Theme": "Thema",
  "Room Information": "Rauminformation",
  "Task Details": "Aufgabendetails",
  "Assignment": "Zuweisung",
  "Due Date": "Fälligkeitsdatum",
  "Room Details": "Raumdetails",
  "Address": "Adresse",
  "People": "Personen",
  "Pending": "Ausstehend",
  "Approved": "Genehmigt",
  "Room Info": "Rauminformation",
  "To be submitted at the of course": "Am Ende des Kurses einreichen",
  "Add Course": "Kurs hinzufügen",
  "Add Location": "Standort hinzufügen",
  "Add Tags": "Tags hinzufügen",
  "Course Date": "Kursdatum",
  "Allowed Persons": "Personen",
  "Add a Title": "Titel hinzufügen",
  "Headline": "Überschrift",
  "Types": "Typen",
  "Enter headline": "Überschrift eingeben",
  "Enter content": "Inhalt eingeben",
  "News Highlight": "News hervorheben",
  "Club News": "Vereinsnachrichten",
  "Company News": "Unternehmensnachrichten",
  "New from the club": "Neu vom Verein",
  "New Posts": "Neue Beiträge",
  "Task Events": "Aufgaben Events",
  "Groups": "Gruppen",
  "Group Details": "Gruppendetails",
  "Delete Group": "Gruppe löschen",
  "Leave Group": "Gruppe verlassen",
  "Join Group": "Gruppe beitreten",
  "Join": "Beitreten",
  "Group Name": "Gruppenname",
  "Course Name": "Kursname",
  "Visibility": "Sichtbarkeit",
  "No file chosen": "Keine Datei ausgewählt",
  "Assign a task to course": "Eine Aufgabe dem Kurs zuweisen",
  "Please fill all required fields": "Bitte füllen Sie alle erforderlichen Felder aus",
  "Room Availability": "Raumverfügbarkeit",
  "Room Capacity": "Raumkapazität",
  "Room Charges": "Raumgebühren",
  "Room Current Bookings": "Aktuelle Buchungen für den Raum",
  "Instructor Availability": "Verfügbarkeit des Kursleiter",
  "Instructor Current Bookings": "Aktuelle Buchungen des Kursleiter",
  "Instructor not available for the following dates and times": "Kursleiter nicht verfügbar für die folgenden Termine und Zeiten",
  "Room not available for the following dates and times": "Raum nicht verfügbar für die folgenden Termine und Zeiten",
  "Not within availability": "Nicht innerhalb der Verfügbarkeit",
  "Add News": "Nachrichten hinzufügen",
  "Waiting for Approval": "Warten auf Genehmigung",
  "Are you sure you want to complete this": "Sind Sie sicher, dass Sie dies abschließen möchten",
  "Please complete all subtasks before marking the task as completed": "Bitte schließen Sie alle Unteraufgaben ab, bevor Sie die Aufgabe als abgeschlossen markieren",
  "wants to join a Group": "möchte einer Gruppe beitreten",
  "wants to publish an updated Group": "möchte eine aktualisierte Gruppe veröffentlichen",
  "has updated the Group": "hat die Gruppe aktualisiert",
  "invited you to": "hat dich eingeladen zu",
  "wants to publish a Group": "möchte eine Gruppe veröffentlichen",
  "has denied the Group": "hat die Gruppe abgelehnt",
  "has been added to the Group": "wurde der Gruppe hinzugefügt",
  "has published the Group": "hat die Gruppe veröffentlicht",
  "wants to publish a News": "möchte eine News veröffentlichen",
  "wants to publish an updated News": "möchte eine aktualisierte News veröffentlichen",
  "has denied the News": "hat die News abgelehnt",
  "has published the News": "hat die News veröffentlicht",
  "has updated the News": "hat die News aktualisiert",
  "wants to publish an Event": "möchte ein Event veröffentlichen",
  "wants to publish an updated Event": "möchte ein aktualisiertes Event veröffentlichen",
  "has denied the Event": "hat das Event abgelehnt",
  "has published the Event": "hat das Event veröffentlicht",
  "has updated the Event": "hat das Event aktualisiert",
  "invited you to an Event": "hat Dich zu einem Event eingeladen",
  "has updated Event for existing users": "hat ein Event aktualisiert",
  "has updated Course for existing users": "hat ein Kurs aktualisiert",
  "wants to publish a Course": "möchte einen Kurs veröffentlichen",
  "wants to publish an updated Course": "möchte einen aktualisierten Kurs veröffentlichen",
  "wants to join a Course you have created": "möchte einem von dir erstellten Kurs beitreten",
  "has been added to a Course by the creator": "wurde einem Kurs hinzugefügt",
  "invited you to a Course": "hat Dich zu einem Kurs eingeladen",
  "wants to assign Instructor to a Course": "möchte einen Kursleiter für einen Kurs hinzufügen",
  "wants to update assigned Instructor of a Course": "möchte einen Kursleiter für einen Kurs hinzufügen",
  "has published the Course": "hat den Kurs veröffentlicht",
  "has updated the Course": "hat den Kurs aktualisiert",
  "has denied the Course": "hat den Kurs abgelehnt",
  "invited you to a Task": "hat Dich zu einer Aufgabe eingeladen",
  "wants to publish a Task": "möchte eine Aufgabe veröffentlichen",
  "wants to publish an updated Task": "möchte eine aktualisierte Aufgabe veröffentlichen",
  "has unapproved the Task": "hat die Aufgabe abgelehnt",
  "has unapproved the Subtask": "hat die Unteraufgabe abgelehnt",
  "has denied the Task": "hat die Aufgabe abgelehnt",
  "has published the Task": "hat die Aufgabe veröffentlicht",
  "has updated the Task": "hat die Aufgabe aktualisiert",
  "has completed the Task": "hat die Aufgabe abgeschlossen",
  "has sent you a message": "hat dir eine Nachricht gesendet",
  "wants to publish a Survey": "möchte eine Umfrage veröffentlichen",
  "wants to publish an updated Survey": "möchte eine aktualisierte Umfrage veröffentlichen",
  "has invited you to participate in a Survey": "hat Sie zur Teilnahme an einer Umfrage eingeladen",
  "has published the Survey": "hat die Umfrage veröffentlicht",
  "has updated the Survey": "hat die Umfrage aktualisiert",
  "has denied the Survey": "hat die Umfrage abgelehnt",
  "wants to publish a Room": "möchte einen Raum erstellen",
  "wants to publish an updated Room": "möchte einen Raum aktualisieren",
  "has published the Room": "hat den Raum erstellt",
  "has updated the Room": "hat den Raum aktualisiert",
  "has denied the Room": "hat den Raum gelöscht",
  "wants to publish an Instructor": "Möchte einen Kursleiter erstellen",
  "wants to publish an updated Instructor": "Möchte einen Kursleiter aktualisieren",
  "has denied the Instructor": "hat den Kursleiter abgelehnt",
  "has published the Instructor": "hat den Kursleiter erstellt",
  "has updated the Instructor": "hat den Kursleiter aktualisiert",
  "wants to publish an FAQ": "Möchte eine FAQ erstellen",
  "wants to publish an updated FAQ": "Möchte eine FAQ aktualisieren",
  "has published the FAQ": "hat die FAQ erstellt",
  "wants to publish an updated FAQ to author": "Möchte eine FAQ aktualisieren",
  "wants to publish an FAQ category": "Möchte eine FAQ Kategorie veröffentlichen",
  "Unknown notification type": "Unbekannter Benachrichtigungstyp",
  "Occupancy": "Belegung",
  "Free": "Frei",
  "Calendar": "Kalender",
  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mär",
  "Apr": "Apr",
  "May": "Mai",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Okt",
  "Nov": "Nov",
  "Dec": "Dez",
  "mo": "Mo",
  "tu": "Di",
  "we": "Mi",
  "th": "Do",
  "fr": "Fr",
  "sa": "Sa",
  "su": "So",
  "mo 1": "M",
  "tu 1": "D",
  "we 1": "M",
  "th 1": "D",
  "fr 1": "F",
  "sa 1": "S",
  "su 1": "S",
  "current": "Aktuell",
  "all": "Alle",
  "monday": "Montag",
  "tuesday": "Dienstag",
  "wednesday": "Mittwoch",
  "thursday": "Donnerstag",
  "friday": "Freitag",
  "saturday": "Samstag",
  "sunday": "Sonntag",
  "january": "Januar",
  "february": "Februar",
  "march": "März",
  "april": "April",
  "may": "Mai",
  "june": "Juni",
  "july": "Juli",
  "august": "August",
  "september": "September",
  "october": "Oktober",
  "november": "November",
  "december": "Dezember",
  "just now": "gerade eben",
  "a minute ago": "vor einer Minute",
  "minutes ago": "vor Minuten",
  "an hour ago": "vor einer Stunde",
  "hours ago": "vor Stunden",
  "yesterday": "gestern",
  "a week ago": "vor einer Woche",
  "weeks ago": "vor Wochen",
  "Click to download": "Klicken zum Herunterladen",
  "Survey Results": "Ergebnis",
  "Survey Results Details": "Umfrageergebnisse Details",
  "Survey Created By": "Umfrage erstellt von",
  "Survey Has been Closed": "Umfrage wurde geschlossen",
  "You've not voted": "Sie haben nicht abgestimmt",
  "My Vote": "Meine Stimme",
  "To Vote": "Abstimmen",
  "My Vote: You can select Multiple Options": "Meine Stimme: Sie können mehrere Optionen auswählen",
  "My Vote: You can select only one option": "Meine Stimme: Sie können nur eine Option auswählen",
  "Following people has voted For this option:": "Folgende Personen haben für diese Option gestimmt:",
  "Total Number of Votes for this Option:": "Gesamtzahl der Stimmen für diese Option:",
  "other": "Andere",
  "Members": "Mitglieder",
  "Search Filter": "Suchfilter",
  "Search": "Suche",
  "Search Results": "Suchergebnisse",
  "Last Active": "Zuletzt aktiv",
  "Status": "Status",
  "Role": "Rolle",
  "Online": "Online",
  "Offline": "Offline",
  "List": "Liste",
  "Members List": "Mitgliederliste",
  "Created": "Erstellt",
  "Paid": "Bezahlt",
  "Unpaid": "Unbezahlt",
  "Active": "Aktiv",
  "Inactive": "Inaktiv",
  "Apply Filter": "Filter anwenden",
  "Anonymous": "Anonym",
  "Show hidden events": "Versteckte Events anzeigen",
  "Hide Event": "Event ausblenden",
  "UnHide Event": "Event einblenden",
  "Banner Placement": "Bannerplatzierung",
  "Banner Display Tags": "Banner-Anzeige-Tags",
  "Create New Tag": "Neuen Tag erstellen",
  "Task Type": "Aufgabentyp",
  "Leave Event": "Event verlassen",
  "Join Event": "Event beitreten",
  "Join This Event": "An diesem Event teilnehmen",
  "Join All Events in Series": "An allen Events in der Serie teilnehmen",
  "Join Event on Specific Dates": "Event an bestimmten Terminen beitreten",
  "Accept event": "Event akzeptieren",
  "Deny event": "Event ablehnen",
  "Publish event": "Event veröffentlichen",
  "Event Members": "Eventmitglieder",
  "Event Tasks": "Eventaufgaben",
  "Event Details": "Eventdetails",
  "About group": "Über Gruppe",
  "Show more": "Mehr anzeigen",
  "Your team": "Dein Team",
  "Responsible": "Verantwortlich",
  "Collaborators": "Mitarbeiter",
  "Work Shifts": "Arbeitsschichten",
  "Create Work Shift": "Arbeitsschicht erstellen",
  "NO Of Shifts": "Anzahl der Schichten",
  "No Shifts Data found": "Keine Schichtdaten gefunden",
  "Error while fetching Shifts Details": "Fehler beim Abrufen von Schichtdetails",
  "Shift": "Schicht",
  "Form": "Formular",
  "No new notifications": "Keine neuen Benachrichtigungen",
  "No Data": "Keine Daten",
  "Add Work-shifts to an event": "Arbeitsschichten zu einem Event hinzufügen",
  "Click to open details": "Klicken, um Details zu öffnen",
  "permanently": "dauerhaft",
  "Folder": "Ordner",
  "Star Message": "Nachricht markieren",
  "Unstar Message": "Nachricht nicht markieren",
  "Impressum": "Impressum",
  "Terms and Conditions": "Allgemeine Geschäftsbedingungen",
  "Terms of Use": "Nutzungsbedingungen",
  "Privacy Policy": "Datenschutzerklärung",
  "You can find our applicable documents here": "Hier finden Sie unsere geltenden Dokumente",
  "Club Administration": "Vereinsverwaltung",
  "Financial Accounting": "Finanzbuchhaltung",
  "License & More": "Lizenz & Mehr",
  "Documents": "Dokumente",
  "Current Statuses": "Aktuelle Satzung",
  "Corporate Philosophy": "Unternehmensphilosophie",
  "Corporate": "Unternehmen",
  "Archive": "Archiv",
  "All": "Alle",
  "Tables": "Tabellen",
  "Images": "Bilder",
  "Delete File": "Datei löschen",
  "Download File": "Datei herunterladen",
  "Preview Image": "Bildvorschau",
  "Upload Document": "Dokument hochladen",
  "Move to My Documents": "In meine Dokumente verschieben",
  "Move to Archived": "In Archivierte verschieben",
  "Move to Current Statuses": "In Aktuelle Satzung verschieben",
  "Move to Club Documents": "In Vereins-Dokumente verschieben",
  "Move to Corporate Documents": "In Unternehmensdokumente verschieben",
  "Move to Corporate Philosophy": "In Unternehmensphilosophie verschieben",
  "Ascending": "Aufsteigend",
  "Descending": "Absteigend",
  "Order By": "Sortieren nach",
  "Order": "Reihenfolge",
  "date": "Datum",
  "name": "Name",
  "Are you sure you want to move": "Sind Sie sicher, dass Sie verschieben möchten",
  "Document moved successfully": "Dokument erfolgreich verschoben",
  "Only PDF files are allowed in Current Statuses": "Nur PDF-Dateien sind in aktuellen Status erlaubt",
  "Upload Successful": "Hochladen erfolgreich",
  "Profile": "Profil",
  "Attachment": "Anhang",
  "Download Attachment": "Anhang herunterladen",
  "Author": "Autor",
  "CRM Surveys": "CRM-Umfragen",
  "CRM Survey": "CRM-Umfrage",
  "Voting Results": "Abstimmungsergebnisse",
  "Total Votes": "Gesamtstimmen",
  "Votes": "Stimme",
  "Close": "Schließen",
  "Thank you for your vote": "Vielen Dank für Ihre Stimme",
  "By": "Von",
  "CRM News": "CRM-Nachrichten",
  "Read": "Gelesen",
  "Mark all notifications as read": "Alle Benachrichtigungen als gelesen markieren",
  "Close this notification": "Diese Benachrichtigung schließen",
  "Phone": "Telefon",
  "Published by": "Veröffentlicht von",
  "Deleted User": "Gelöschter Benutzer",
  "Delete Chat": "Chat löschen",
  "Availability": "Verfügbarkeit",
  "Enter Name": "Name eingeben",
  "Enter Email": "E-Mail eingeben",
  "Phone No": "Telefonnummer",
  "Enter Phone No": "Telefonnummer eingeben",
  "Enter Address": "Adresse eingeben",
  "No Of Persons": "Anzahl der Personen",
  "Enter No Of Persons": "Anzahl der Personen eingeben",
  "Price": "Preis",
  "First Name": "Vorname",
  "Enter First Name": "Vorname eingeben",
  "Last Name": "Nachname",
  "Enter Last Name": "Nachname eingeben",
  "Enter Qualification": "Qualifikation eingeben",
  "Repeat Course": "Kurs wiederholen",
  "Delete Selected": "Ausgewählte löschen",
  "Deselect All": "Alle abwählen",
  "Statistics": "Statistik",
  "Banner Statistics": "Bannerstatistik",
  "Banner Desktop Clicks": "Banner Desktop Klicks",
  "Clicks": "Klicks",
  "Select Admin": "Administrator auswählen",
  "Group Chat": "Gruppen Chat",
  "Groupchat": "Gruppenchat",
  "Personal Chat": "Persönlicher Chat",
  "Created By": "Erstellt von",
  "Invoice": "Rechnung",
  "Profile Image": "Profilbild",
  "Share Birthday": "Geburtstag teilen",
  "Allow Advertisement": "Werbung zulassen",
  "Date From": "Datum von",
  "Date To": "Datum bis",
  "m ago": "vor {{count}} Minute(n)",
  "h ago": "vor {{count}} Stunde(n)",
  "d ago": "vor {{count}} Tag(en)",
  "w ago": "vor {{count}} Woche(n)",
  "mo ago": "vor {{count}} Monat(en)",
  "Completed Subtasks": "Abgeschlossene Unteraufgaben",
  "Total Subtasks": "Unteraufgaben",
  "Task Assigned to": "Aufgabe zugewiesen an",
  "To be done by": "Erledigen bis",
  "This Task Only Completed by Admin, Organizer and Collaborators of this Task": "Diese Aufgabe kann nur von Administrator, Organisator und Mitarbeitern dieser Aufgabe abgeschlossen werden",
  "You do not have permission to complete this subtask, only participants of this Task & Subtasks, organizer of this task, and Administrator can complete this subtask": "Sie haben keine Berechtigung, diese Unteraufgabe zu erledigen. Nur Teilnehmer dieser Aufgabe und Unteraufgaben, Organisator dieser Aufgabe und Administrator können diese Aufgabe erledigen",
  "Desktop": "Web",
  "Notification Section": "Benachrichtigungen",
  "Everywhere": "Überall",
  "Welcome to your club community!": "Willkommen in deiner Vereins-Community!",
  "Stay networked with your club, exchange ideas and organize everything in one place.": "Bleib mit deinem Verein vernetzt, tausche dich aus und organisiere alles an einem Ort.",
  "Everything you need for your club - in one place.": "Alles, was du für deinen Verein brauchst – an einem Platz.",
  "Simply register, contact members, plan appointments and achieve more together.": "Einfach anmelden, Mitglieder kontaktieren, Termine planen und gemeinsam mehr erreichen.",
  "Stay connected - anytime, anywhere.": "Verbunden bleiben – jederzeit und überall.",
  "Access important information, share news and collaborate with your team.": "Greife auf wichtige Infos zu, teile Neuigkeiten und arbeite mit deinem Team zusammen.",
  "Happy Birthday": "Alles Gute zum Geburtstag",
  "Happy Anniversary": "Alles Gute zum Jubiläum",
  "Instant and uncomplicated chatting with members or groups": "Sofort und unkompliziert mit Mitgliedern oder Gruppen chatten",
  "Your own mailbox based on the classic e-mail": "Das eigene Postfach angelehnt an die klassische E-Mail",
  "Invalid file type or size. Only PNG, JPEG images and allowed documents under 10MB are allowed": "Ungültiger Dateityp oder Größe. Nur PNG, JPEG-Bilder und erlaubte Dokumente unter 10MB sind erlaubt",
  "Club Overview": "Vereins-Übersicht",
  "Happenings": "Ereignisse",
  "Occasions": "Ereignisse",
  "No:": "Nr:",
  "Password changed successfully. Please login again": "Passwort erfolgreich geändert. Bitte melden Sie sich erneut an",
  "This is a private group. You need to request to join this group": "Dies ist eine private Gruppe. Sie müssen eine Anfrage stellen, um dieser Gruppe beizutreten",
  "Your request to join this group is pending": "Ihre Anfrage, dieser Gruppe beizutreten, ist ausstehend",
  "Your request to join this group has been rejected": "Ihre Anfrage, dieser Gruppe beizutreten, wurde abgelehnt",
  "Confirm Delete": "Löschen bestätigen",
  "No news has been created in the club yet": "Es wurde noch keine News im Verein erstellt",
  "No news has been created in any Group yet": "Es wurde noch keine News in einer Gruppe erstellt",
  "No group has been created in the club yet": "Es wurde noch keine Gruppe im Verein erstellt",
  "No events available": "Keine Events verfügbar",
  "Additional address": "Zusatzadresse",
  "You have no notifications": "Sie haben keine Benachrichtigungen",
  "Information about the course": "Informationen zum Kurs",
  "Further information about the course": "Weitere Informationen zum Kurs",
  "Invite Participants": "Teilnehmer einladen",
  "Select all": "Alle auswählen",
  "Unselect all": "Alle abwählen",
  "Done": "Fertig",
  "You already have a pending change request": "Sie haben bereits eine ausstehende Änderungsanfrage",
  "Messages": "Nachrichten",
  "Calendar view": "Kalenderansicht",
  "Card view": "Kachelansicht",
  "Mark As Complete": "Als abgeschlossen markieren",
  "No Bookings": "Keine Buchungen",
  "Schedule view": "Zeitplanansicht",
  "Hide Empty Slots": "Leere Zeitfenster ausblenden",
  "Group Filter": "Gruppenfilter",
  "No Conversation": "Keine Konversation",
  "Select Event Dates": "Termine auswählen",
  "Select the dates you want to join for this event": "Wählen Sie die Termine aus, an denen Sie an dieser Eventserie teilnehmen möchten",
  "Join Selected Dates": "Ausgewählte Termine bestätigen",
  "Selected": "Ausgewählt",
  "dates": "Terminen",
  "new": "neu",
  "Please select at least one new date": "Bitte wählen Sie mindestens ein neues Datum aus",
  "No available dates for this event": "Keine verfüg aren Daten für dieses Event",
  "Accept This Event": "Diese Veranstaltung annehmen",
  "Accept All Events in Series": "Alle Veranstaltungen der Reihe annehmen",
  "Accept Event on Specific Dates": "Veranstaltung an bestimmten Terminen annehmen",
  "SPACER FOR THE BOTTOM": "----------------------------------------------------------SPACER FOR THE BOTTOM---------------------------------------------------------------------",
  "formErrors": {
    "is required.": "ist erforderlich.",
    "is invalid.": "ist ungültig.",
    "is required to be at least": "muss mindestens sein",
    "cannot be longer than": "darf nicht länger sein als",
    "can't be greater than": "darf nicht größer sein als",
    "can't be less than": "darf nicht kleiner sein als",
    "must contain at least 1 in Capital Case!": "muss mindestens 1 Großbuchstaben enthalten!",
    "must contain at least 1 Letter in Small Case!": "muss mindestens 1 Kleinbuchstaben enthalten!",
    "must contain at least 1 Special Character!": "muss mindestens 1 Sonderzeichen enthalten!",
    "do not match.": "stimmen nicht überein.",
    "must be unique.": "muss eindeutig sein.",
    "must be greater than 0.": "muss größer als 0 sein.",
    "must be greater.": "muss größer sein.",
    "must be greater than or equal.": "muss größer oder gleich sein.",
    "must be after the start date.": "muss nach dem Startdatum sein.",
    "invalid pattern": "ungültiges Muster",
    "invalid pattern, 12345-1234 or 12345": "ungültiges Muster, 12345-1234 oder 12345"
  },
  "loginForm": {
    "Login into your account": "Melden Sie sich an",
    "Username": "Benutzername",
    "Password": "Passwort",
    "Remember me": "Erinnere dich an mich",
    "I forgot my password": "Ich habe mein Passwort vergessen",
    "Don't have an account?": "Sie haben noch kein Konto?",
    "Login": "Anmelden",
    "Sign up for Verein.cloud": "Registrieren Sie sich für verein.cloud®",
    "Password (6+ characters)": "Passwort (6+ Zeichen)"
  },
  "buttonComponent": {
    "Login": "Anmelden",
    "Success": "Erfolg",
    "Save": "Speichern",
    "Processing": "Verarbeitung",
    "Error": "Fehler",
    "Cancel": "Abbrechen",
    "done": "Fertig",
    "Join Event": "Event beitreten",
    "Leave Event": "Event verlassen"
  },
  "header": {
    "open": "Öffnen",
    "close": "Schließen",
    "start typing": "Suche eingeben.",
    "messages": "Nachrichten"
  },
  "nav": {
    "event tasks": "Event Tasks",
    "event members": "Event Members",
    "create event form": "Create Event Form",
    "dashboard": "Übersicht",
    "news": "News",
    "clubWall": "Club-Wand",
    "community": "Community",
    "organizer": "Organisator",
    "courses": "Kurse",
    "tasks": "Aufgaben",
    "events": "Events",
    "messages": "Nachrichten",
    "settings": "Einstellungen",
    "appointments": "Termine",
    "task&appointments": "Aufgaben & Termine",
    "messages&groups": "Nachrichten & Gruppen",
    "groups": "Gruppen",
    "academic": "Akademisch",
    "app store": "App Store",
    "my profile": "Mein Profil",
    "profile": "Profil",
    "club tools": "Vereins Tools",
    "marketing": "Marketing",
    "marketing tools": "Marketing-Tools",
    "banners": "Banners",
    "create banner": "Banner erstellen",
    "create event": "Event erstellen",
    "emails": "E-Mails",
    "create email": "E-Mail erstellen",
    "tags": "Tags",
    "survey": "Umfragen",
    "course management": "Kursverwaltung",
    "club FAQs": "Vereins FAQs",
    "group details": "Gruppendetails",
    "chat": "Chat",
    "events & club dates": "Events & Clubtermine",
    "club addons": "Club-Erweiterungen",
    "more": "Mehr",
    "documents": "Dokumente",
    "add": "Hinzufügen",
    "faq": "FAQ",
    "my content": "Meine Inhalte"
  },
  "dashboard": {
    "news posts": "News Beiträge",
    "posts": "Beiträge",
    "message chats": "Nachrichten Chats",
    "tasks events": "Aufgaben Events",
    "tasks": "Tasks",
    "news from the club": "Nachrichten aus dem Verein",
    "current club dates": "Aktuelle Termine im Verein",
    "participant": "Teilnehmer",
    "read more": "Mehr lesen",
    "clock": "Uhr",
    "popular": "Beliebt",
    "latest": "Neueste",
    "Available Tasks": "Verfügbare Aufgaben",
    "message": "Message",
    "chats": "Chats",
    "available": "Verfügbar"
  },
  "community": {
    "group overview": "Gruppen-Übersicht",
    "dashboard": "Armaturenbrett",
    "community": "Gemeinschaft",
    "messages": "Nachrichten",
    "groups": "Gruppen",
    "members": "Mitglieder",
    "open chat": "Chat öffnen",
    "leave": "Verlassen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "add": "Hinzufügen",
    "create": "Erstellen",
    "show all groups": "Alle Gruppen anzeigen",
    "groups you manage": "Gruppen, die Sie verwalten",
    "groups you are a member of": "Gruppen, denen Sie angehören"
  },
  "groups": {
    "groups": "Gruppen",
    "group": "Gruppe",
    "group details": "Gruppendetails",
    "group chat": "Gruppenchat",
    "members": "Mitglieder",
    "news": "News",
    "tasks": "Aufgaben",
    "events": "Events",
    "about": "Über",
    "About this group": "Über diese Gruppe",
    "set": "Set",
    "your team": "Dein Team",
    "new": "Neu",
    "group admin": "Gruppenadministrator",
    "age": "Alter",
    "no group": "Keine Gruppe",
    "no event": "Keine Events",
    "no task": "Keine Aufgaben",
    "no news": "Keine News",
    "no member": "Kein Mitglied",
    "join success message": "Sie sind erfolgreich der Gruppe beigetreten.",
    "waiting admin approval": "Warten auf die Genehmigung des Administrators",
    "leave success message": "Sie haben die Gruppe erfolgreich verlassen.",
    "delete success message": "Gruppe erfolgreich gelöscht."
  },
  "banners": {
    "link": "Link",
    "content": "Inhalt",
    "description": "Beschreibung",
    "banner status": "Status",
    "update courses": "Kurse aktualisieren",
    "banner invoice": "Rechnung",
    "banner category": "Kategorie",
    "add description": "Beschreibung hinzufügen",
    "create banner": "Banner erstellen",
    "thumbnail": "Vorschaubild",
    "add image": "Bild hinzufügen",
    "title": "Titel",
    "banner categories": "Bannerkategorien",
    "banner images": "Bannerbilder",
    "banner link": "Banner link",
    "sponsor": "Sponsor",
    "open space": "Freiraum",
    "app sponsor": "App Sponsor",
    "group details": "Gruppendetails",
    "all groups": "Alle Gruppen",
    "all news": "Alle News",
    "not paid": "Nicht bezahlt",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "banner title": "Bannertitel",
    "edit banner": "Banner bearbeiten",
    "banner display": "Anzeige",
    "news details": "News Details",
    "banner placement": "Platzierung",
    "banner display tag": "Banneranzeige Tag",
    "banner redirect link": "Weiterleitungslink"
  },
  "dates&filters": {
    "date": "Datum",
    "days": "Tage",
    "day": "Tag",
    "hour": "Stunde",
    "hours": "Stunden",
    "time": "Zeit",
    "year": "Jahr",
    "years": "Jahre",
    "month": "Monat",
    "months": "Monate",
    "week": "Woche",
    "weeks": "Wochen",
    "opinion": "Meinung",
    "event type": "Eventtyp",
    "sort and filter": "Sortieren und Filtern",
    "clear filters": "Filter löschen",
    "clear": "Löschen",
    "expired": "Abgelaufen"
  },
  "messages": {
    "new group": "Neue Gruppe",
    "new chat": "Neuer Chat",
    "chat": "Chat",
    "personal": "Persönlich",
    "club": "Club",
    "group": "Gruppe",
    "clubs": "Clubs",
    "members": "Mitglied",
    "write a message": "Nachricht schreiben",
    "media links and docs": "Medien, Links und Dokumente",
    "group in common": "Gemeinsame Gruppe",
    "close": "Schließen",
    "group name": "Gruppenname",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "delete": "Löschen",
    "report": "Melden",
    "no messages yet": "Noch keine Nachrichten",
    "start the conversation": "Starten Sie das Gespräch"
  },
  "tags": {
    "tag": "Tag",
    "tags": "Tags",
    "tag name": "Tag Name",
    "create tag": "Tag erstellen",
    "instructor tag name": "Instructor Tag Name",
    "room tag name": "Raum Tag Name",
    "instructor": "Kursleiter",
    "room": "Raum",
    "new tag": "Neuer Tag"
  },
  "users": {
    "my profile": "Mein Profil",
    "user profile": "Benutzerprofil",
    "user": "Benutzer",
    "general information": "Allgemeine Informationen",
    "my payment data": "Meine Zahlungsdaten",
    "association master data": "Vereinsstammdaten",
    "me at the club": "Ich im Verein",
    "I in the company": "Ich im Unternehmen",
    "my address information": "Meine Adressinformationen",
    "communication data": "Kommunikation",
    "street number": "Straße",
    "more info": "Weitere Informationen",
    "city": "Stadt",
    "zip code": "Postleitzahl",
    "e-mail address": "E-Mail-Adresse",
    "phone number": "Telefonnummer",
    "date of birth": "Geburtstag",
    "address supplement": "Adresszusatz",
    "save profile": "Profil speichern",
    "password information": "Passwortinformation",
    "old password": "Altes Passwort",
    "minimum 6 characters": "Mindestens 6 Zeichen",
    "change": "Ändern",
    "bank holder name": "Kontoinhaber",
    "iban": "IBAN",
    "bic": "BIC",
    "social links": "Social Links",
    "facebook": "Facebook",
    "twitter": "Twitter",
    "instagram": "Instagram",
    "homepage": "Homepage",
    "country": "Land",
    "bank name": "Bankname",
    "member ship start date": "Mitgliedschaftsbeginn",
    "My role in verein.cloud®": "Meine Rolle in verein.cloud®"
  },
  "club_tools": {
    "create question": "Frage erstellen",
    "faq categories": "FAQ Kategorien",
    "start searching": "Suche starten",
    "membership": "Mitgliedschaft",
    "maintenance and care": "Wartung und Pflege",
    "create faq": "Erstellen FAQ",
    "update faq": "Aktualisieren FAQ",
    "create title": "Titel erstellen",
    "add description here": "Hier Beschreibung hinzufügen"
  },
  "courses": {
    "instructors": "Kursleiter",
    "rooms": "Räume",
    "all instructors": "Alle Kursleiter",
    "all rooms": "Alle Räume",
    "today": "Heute",
    "upcoming": "Kommende",
    "join": "Beitreten",
    "joined": "Beigetreten",
    "rejected": "Abgelehnt",
    "persons": "Personen",
    "search by room name": "Nach Raumnamen suchen",
    "join course": "Kurs beitreten",
    "sorting": "Sortierung",
    "participants": "Teilnehmer",
    "about course": "Über den Kurs",
    "course details": "Kursdetails"
  },
  "appointmentAndClub": {
    "start time": "Startzeit",
    "end time": "Endzeit",
    "visibility": "Sichtbarkeit",
    "event name": "Event Name",
    "event location": "Event Ort",
    "room number (optional)": "Raumnummer (optional)",
    "event price": "Event Preis",
    "additional features": "Zusätzliche Funktionen",
    "show guests": "Gäste anzeigen",
    "chargeable": "Kostenpflichtig",
    "create event": "Event erstellen",
    "edit event": "Event bearbeiten",
    "canceled": "Abgesagt",
    "pending": "Ausstehend",
    "confirmed": "Bestätigt",
    "location": "Ort",
    "responsible": "Verantwortlich",
    "join event": "Event beitreten",
    "current": "Aktuell",
    "tile view": "Kachelansicht",
    "list view": "Listenansicht",
    "board": "Board",
    "view": "Ansicht",
    "my contributions": "Meine Beiträge",
    "Birthdays and anniversaries in the club": "Geburtstage und Jubiläen im Verein",
    "Current events in the club": "Aktuelle Veranstaltungen im Verein",
    "Current events in the company": "Aktuelle Veranstaltungen im Unternehmen"
  },
  "calendar": {
    "mo": "Mo",
    "tu": "Di",
    "we": "Mi",
    "th": "Do",
    "fr": "Fr",
    "sa": "Sa",
    "su": "So",
    "mo 1": "M",
    "tu 1": "D",
    "we 1": "M",
    "th 1": "D",
    "fr 1": "F",
    "sa 1": "S",
    "su 1": "S",
    "current": "Aktuell",
    "all": "Alle",
    "monday": "Montag",
    "tuesday": "Dienstag",
    "wednesday": "Mittwoch",
    "thursday": "Donnerstag",
    "friday": "Freitag",
    "saturday": "Samstag",
    "sunday": "Sonntag",
    "january": "Januar",
    "february": "Februar",
    "march": "März",
    "april": "April",
    "may": "Mai",
    "june": "Juni",
    "july": "Juli",
    "august": "August",
    "september": "September",
    "october": "Oktober",
    "november": "November",
    "december": "Dezember"
  },
  "my content": {
    "title image": "Titelbild",
    "type": "Typ",
    "actions": "Aktionen",
    "faqs": "FAQ's"
  },
  "userprofile": {
    "personal information": "Persönliche Informationen",
    "create profile": "Profil erstellen",
    "edit my profile": "Mein Profil bearbeiten",
    "digital membership card": "Digitale Mitgliedskarte",
    "payment information": "Zahlungsinformationen",
    "digital card": "Digitale Karte",
    "card holder name": "Karteninhabername",
    "card number": "Kartennummer",
    "card type": "Kartentyp",
    "expiration date": "Ablaufdatum",
    "membership information": "Mitgliedschaftsinformationen",
    "membership type": "Mitgliedschaftstyp",
    "membership number": "Mitgliedsnummer",
    "In the team since": "im Verein seit",
    "approval / activation": "Genehmigung / Aktivierung",
    "fair-share function": "Fair-Share-Funktion"
  },
  "RRULE": {
    "approximate": "ungefähr",
    "and": "und",
    "at": "um",
    "day": "Tag",
    "days": "Tage",
    "every": "Jede(n)",
    "for": "für",
    "hour": "Stunde",
    "hours": "Stunden",
    "in": "in",
    "last": "letzte(n)",
    "minutes": "Minuten",
    "month": "Monat",
    "months": "Monate",
    "nd": "nd",
    "on the": "am",
    "on": "am",
    "or": "oder",
    "rd": "rd",
    "st": "st",
    "th": "th",
    "the": "der",
    "time": "Mal",
    "times": "Mal",
    "until": "bis",
    "week": "Woche",
    "weekday": "Wochentag",
    "weekdays": "Werktage",
    "weeks": "Wochen",
    "year": "Jahr",
    "years": "Jahre",
    "monthly": "Monatlich",
    "starting from": "beginnend ab",
    "yearly": "jährlich",
    "weekly": "wöchentlich",
    "daily": "täglich",
    "hourly": "stündlich",
    "minutely": "minütlich",
    "secondly": "sekündlich",
    "MO": "Montag",
    "TU": "Dienstag",
    "WE": "Mittwoch",
    "TH": "Donnerstag",
    "FR": "Freitag",
    "SA": "Samstag",
    "SU": "Sonntag",
    "RRule error: Unable to fully convert this rrule to text": "RRule-Fehler: Konnte diese RRule nicht vollständig in Text umwandeln"
  }
}
